
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mvp-aplikacji-lub-urzadzenia",
      function () {
        return require("private-next-pages/mvp-aplikacji-lub-urzadzenia.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mvp-aplikacji-lub-urzadzenia"])
      });
    }
  